const { MEDIUM } = require('../constants/timeouts');
const fetch = require('./fetch');

const defaultTimeout = MEDIUM;

module.exports = (url, options = {}, timeout = defaultTimeout) => {
  const controller = new fetch.AbortController();
  const to = setTimeout(() => controller.abort(), timeout);
  const attempt = fetch(url, { ...options, signal: controller.signal });

  attempt.then(() => clearTimeout(to))
    .catch(() => clearTimeout(to));

  return attempt;
};

module.exports.defaultTimeout = defaultTimeout;
